import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import { formatMobile, formatCardNumber } from '../../components/global/FormatString'
import BookingAlert from '../../components/global/BookingAlert'
import CommonBtn from '../../components/global/CommonBtn'
import MultipleEventCrousel from '../../components/global/MultipleEventCrousel'
import EventCard from '../../components/global/EventCard'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '../../constants/globalConstants'
import { clearSessionDetails, convertParkingTime } from '../../utils/helper'
import Loader from '../../components/global/Loader'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { globalKeyStore } from '../../redux/actions/globalState'

function Success({ dispatch, paymentResponse, selectEventType, eventData, paymentSession, card, phone, bookingFormDetail, selectedCard }) {

	const [paymentStatus, setPaymentStatus] = useState(false)
	const [systemError, setSystemError] = useState(false)
	const [systemErrorMessage, setSystemErrorMessage] = useState('')
	const [isLoading, setIsLoading] = useState(false)
	const { pathname } = useLocation()
	const localFacilityId = JSON.parse(localStorage.getItem('selectedFacilityId'))
    const [facilityDet, setFacilityDet] = useState({
        name: null,
        defaultPrice: '0.00'
    })
	const {facility} = useParams()
	const partnername = pathname?.split('/')?.filter(v => v != '')

	const navigate = useNavigate()


	useEffect(() => {
		setIsLoading(true)
		window.scrollTo(0, 0)

		// payemnt response
		const paymentResponseLocal = (localStorage.getItem('paymentResponse')) ? JSON.parse(localStorage.getItem('paymentResponse')) : EMPTY_OBJECT

		// for the Event Type
		const selectedEventTypeLoc = localStorage.getItem('selectEventType')

		// for showing data
		let bookingFormDetail = localStorage?.getItem('bookingFormDetail') ? localStorage?.getItem('bookingFormDetail') : '{}'
		const { event_data, sessionDetails, personal_info, payment_detail, get_event_type } = JSON.parse(bookingFormDetail)
		const { name, email } = (personal_info) ? personal_info : EMPTY_OBJECT
		const phone_number_format = formatMobile(personal_info?.phone)
		const card = payment_detail?.card_pan ? formatCardNumber(payment_detail?.card_pan) : selectedCard?.card_last_four ? formatCardNumber('000000000000' + selectedCard?.card_last_four) : ''

		dispatch(globalKeyStore({
			paymentResponse: paymentResponseLocal,
			selectEventType: selectedEventTypeLoc,
			eventData: event_data,
			paymentSession: sessionDetails?.data,
			card: card,
			phone: phone_number_format,
			bookingFormDetail: JSON.parse(bookingFormDetail),
		}))

		if (selectedEventTypeLoc == 'event') {
			dispatch(globalKeyStore({ eventData: event_data }))
		} else {
			dispatch(globalKeyStore({ passData: event_data }))
		}

		if ((paymentResponseLocal?.anet_transaction_id !== '' && paymentResponseLocal?.anet_transaction_id !== null && paymentResponseLocal?.anet_transaction_id !== undefined)) {
			setPaymentStatus(true)
			setSystemError(false)
			setSystemErrorMessage('')
			setIsLoading(false)

			setTimeout(() => {
				clearSessionDetails()
			}, 2000)
		} else if (!name || name == '' || !email || email == '' || !get_event_type || get_event_type == '' || !event_data || event_data == '') {
			dispatch(globalKeyStore({ isLoading: true }))
			clearSessionDetails()
			if(facility){
				navigate(`/${partnername?.[0]}/${facility}`)
			}else{
				navigate(`/${partnername?.[0]}`)
			}
			navigate(0)
		}
		if(eventData.length > 0 && eventData[0]?.facilities?.length) {
            let facilityName = eventData[0].facilities.filter((item) => item.id === localFacilityId )
            if(facilityName.length > 0) {
                setFacilityDet({...facilityDet, defaultPrice: facilityName[0].base_event_rate, name: facilityName[0].full_name})
            }
        }
	}, [EMPTY_ARRAY])

	return (
		<div>
			{(isLoading) ? <div className='d-flex align-content-center flex-wrap vh-100 justify-content-center'><Loader /></div>  :
				<div className="container my-5">
					<div className="position-relative m-4 mb-5">
						<div className="progress" role="progressbar" aria-label="Progress" aria-valuenow="50" aria-valuemin="0" aria-valuemax="100" style={{ height: '1px' }}>
							<div className="progress-bar" style={{ width: '100%' }}></div>
						</div>
						<CommonBtn isProgressBtn className={'position-absolute top-0 start-0 translate-middle btn btn-sm btn-primary rounded-pill'} value={'1'} style={{ width: '2rem', height: '2rem' }} />
						<CommonBtn isProgressBtn className={'position-absolute top-0 start-50 translate-middle btn btn-sm btn-primary rounded-pill'} value={'2'} style={{ width: '2rem', height: '2rem' }} />
						<CommonBtn isProgressBtn className={'position-absolute top-0 start-100 translate-middle btn btn-sm btn-success rounded-pill'} value={'3'} style={{ width: '2rem', height: '2rem' }} />
					</div>
					<BookingAlert
						type={paymentStatus && !systemError ? 'success' : 'error'}
						heading={paymentStatus && !systemError ? 'Your ticket has been booked successfully' : systemErrorMessage}
						message={paymentStatus && !systemError && !paymentResponse?.mapco_qrcode?.length > 0 ? 'Something went wrong while generating tickets. Please do not book again, and save the booking Id for future reference. Contact to our customer support regarding the same.'
							: paymentStatus && !systemError ? `Thank you for the purchase, You can download the ticket for the ${paymentResponse?.mapco_qrcode?.length > 1 ? 'events' : 'event'} below.`
								: paymentStatus && systemError ? systemErrorMessage ? systemErrorMessage : 'Something went wrong. Please check your network connection and try again in some time. If your card is already charged, then please contact our support team.' : 'Something went wrong, please check your card details. If your amount is deducted, please contact to our support team.'}
						paymentResponse={paymentResponse}
					/>


					<section className='mb-3'>
						{selectEventType == 'event' ?
							<EventCard
								key={eventData?.id}
								qrCodeValue={paymentResponse?.mapco_qrcode?.[0]?.qrcode}
								// handleBookingButtton={handleBookingButtton}
								imageUrl={eventData?.image_url ? eventData?.image_url : 'NoImage'}
								title={eventData?.title}
								detials={eventData?.description}
								startDate={eventData?.start_time}
								time={convertParkingTime(eventData?.parking_start_time, eventData?.parking_end_time)}
								paybaleAmount={eventData?.paybaleAmount}
								id={eventData?.id}
								parkingPrice={selectEventType == 'event' ? (eventData?.event_rate === '0.00' || eventData?.event_rate === 0) ? eventData?.facilities?.[0]?.base_event_rate : eventData?.event_rate : eventData?.price}
								amount={eventData?.amount ? eventData?.amount?.toFixed(2) : 0}
								displayQr
								paymentResponse={paymentResponse}
								facilitiesName={facilityDet.name ? facilityDet.name : eventData?.facilities?.[0]?.full_name}
								facilityPrice={facilityDet.defaultPrice}
							/>
							: <MultipleEventCrousel
								displayQr
								hidePaymentDetails
								sessionDetails={paymentSession}
								paymentResponse={paymentResponse}
							/>}
					</section>

					<div className="card">
						<div className="card-body">
							<div className="row">
								<div className="col">
									<div className="d-flex mb-3  align-items-center ">
										<label><b>Personal  Information</b></label>
										<button className="btn btn-sm ms-3  p-0"></button>

									</div>
									<p><b>{bookingFormDetail?.personal_info?.name ? bookingFormDetail?.personal_info?.name : ''}</b><br />  {bookingFormDetail?.personal_info?.email ? bookingFormDetail?.personal_info?.email : ''}<br />  {phone ? phone : ''} </p>
								</div>
								{(card) && <div className="col">
									<div className="d-flex mb-3    align-items-center ">
										<label><b>Payment Details</b></label>
										<button className="btn btn-sm  ms-3  p-0"></button>

									</div>
									<p>
										<i className="fa fa-credit-card" aria-hidden="true"></i> {card} <span className="ms-4"><i className="fa fa-calendar" aria-hidden="true"></i> {(bookingFormDetail?.payment_detail?.card_date_expiry_month && bookingFormDetail?.payment_detail?.card_date_expiry_year) ? bookingFormDetail?.payment_detail?.card_date_expiry_month + '/' + bookingFormDetail?.payment_detail?.card_date_expiry_year : selectedCard.expiry}</span>
									</p>
								</div>}
							</div>
						</div>
						{/* <div className="card-footer ">
							<h5 className="fw-bold text-danger mt-3">Terms & Conditions</h5>
							<p className=""> Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic tempore et eum nisi, voluptas
								ratione delectus, odio architecto quam labore voluptatum ipsum, doloremque ad. Laudantium rerum,
								dicta iste nulla tenetur ea quaerat distinctio ullam veniam, maiores optio libero iusto molestias!
								Omnis eligendi voluptate id eius harum sapiente totam ullam.</p>

								
							<p className=""> Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic tempore et eum nisi, voluptas
								ratione delectus, odio architecto quam labore voluptatum ipsum, doloremque ad. Laudantium rerum,
								dicta iste nulla tenetur ea quaerat distinctio ullam veniam, maiores optio libero iusto molestias!
								Omnis eligendi voluptate id eius harum sapiente totam ullam.</p>
						</div> */}
					</div>
				</div>
			}
		</div>

	)
}

Success.propTypes = {
	dispatch: PropTypes.func,
	notify: PropTypes.func,
	bookingFormDetail: PropTypes.object,
	selectEventType: PropTypes.object,
	eventData: PropTypes.object, isLoading: PropTypes.bool,
	phone: PropTypes.string, card: PropTypes.string,
	paymentSession: PropTypes.object, paymentResponse: PropTypes.object,
	selectedCard: PropTypes.string
}

Success.defaulProps = {
	dispatch: noop,
	notify: noop,
	bookingFormDetail: {},
	selectEventType: EMPTY_OBJECT,
	eventData: EMPTY_OBJECT, isLoading: false,
	phone: '', card: '', paymentSession: EMPTY_OBJECT,
	paymentResponse: EMPTY_OBJECT,
	selectedCard: ''
}


function mapStateToProps({ globalReducers }) {
	return {
		paymentResponse: globalReducers?.paymentResponse,
		selectedPassType: globalReducers?.selectedPassType,
		selectedEventId: globalReducers?.selectedEventId,
		bookingFormPage: globalReducers?.bookingFormPage,
		bookingFormDetail: globalReducers?.bookingFormDetail,
		selectEventType: globalReducers?.selectEventType,
		eventData: globalReducers?.eventData,
		paymentSession: globalReducers?.paymentSession,
		card: globalReducers?.card,
		phone: globalReducers?.phone,
		selectedCard: globalReducers?.selectedCard

	}
}

export default connect(mapStateToProps)(Success)